import { channelIconElement } from '../../components/ChannelLegendItem'
import { SummaryMode } from '../../components/charts'
import type { ChartSeriesInput } from '../../components/charts'
import type { ChannelTimeSeries } from '../hooks/useAllChannelsTimeSeries'

/**
 * Builds the `ChartSeriesProvider` inputs for the All-Channels Followers card:
 * one Latest-mode series per displayed channel over the followers feed. The
 * same series feeds every view — the Line (time-series), Bar (breakdown), and
 * Growth (net-change) charts all derive what they need from it — plus the
 * Share-as-Post export.
 *
 * Colour is left to the provider — each series carries `paletteIndex` = the
 * channel's slot in the full time-series feed (via `paletteIndexById` from
 * {@link useMetricChannels}), so `getChannelColor(paletteIndex)` resolves the
 * same hue the legend and the Posts card use. Passing the displayed-order index
 * instead would shift every colour whenever a leading channel is filtered out.
 *
 * All-Channels never fetches comparison data, so there are no dashed siblings.
 */
export function toFollowersSeries(
  displayedChannels: ChannelTimeSeries[],
  paletteIndexById: Map<string, number>,
): ChartSeriesInput[] {
  return displayedChannels.map((ch) => ({
    id: `followers-${ch.channel.id}`,
    label: ch.channel.name,
    icon: channelIconElement(ch.channel.service),
    summaryMode: SummaryMode.LATEST,
    paletteIndex: paletteIndexById.get(ch.channel.id) ?? 0,
    data: ch.primary.followers.map((p) => ({
      date: p.date,
      value: p.value,
      source: p.source,
    })),
  }))
}
